// src/theme.js
export const appTheme = {
  colors: {
    tealCustom: [
      '#e6f9f4',
      '#c2f0e1',
      '#9ce6ce',
      '#73dcb9',
      '#4ad2a4',
      '#1ab394', // main color
      '#159c82',
      '#10846d',
      '#0a6d59',
      '#055744',
    ],
  },
  primaryColor: 'tealCustom',
  primaryShade: 5,
};
